import createMessages from 'mz-intl/create';

export default createMessages('PRICE_BREAKDOWN', {
  ESTIMATED_RIDE_TIME: 'Estimated Ride Time',
  TIMES_MAY_VARY: 'Actual ride time may vary',
  RIDE_PRICE: 'Ride Price',
  PRICE_PER_VEHICLE: 'Price Per Vehicle',
  PLATFORM_FEE: 'Service & Safety Fee'
});
